<template>
  <div class="filter">
    <div class="mb20">
      <b class="fs16">邮件发送列表</b>
    </div>
    <div class="filterContainer">
      <div class="mr20">
        <span class="w70 tar title">弃单后：</span>
        <a-input-number
          class="mr4"
          v-model:value="timeParams.recallTime"
          :formatter="value => Math.ceil(value)"
          :min="0"
          :max="72"
          :steps="1"
        />
        小时
      </div>
      <div class="mr30">
        <div class="pt5">
          <span class="w140 tar title">弃单邮件激活开关：</span>
          <a-switch
            :checked="timeParams.active - 0 ? true : false"
            @change="() => (timeParams.active = timeParams.active - 0 ? 0 : 1)"
            checked-children="开"
            un-checked-children="关"
          />
        </div>
      </div>
      <div class="mr40">
        <span class="w180 tar title">每一封弃单邮件时间间隔：</span>
        <a-input-number
          class="mr4"
          :steps="1"
          v-model:value="timeParams.intervalTime"
          style="width: 60px;"
          placeholder="请输入"
        />
        天
      </div>
      <a-button type="primary" class="w120" @click="changeTimeSet"
        >保存</a-button
      >
    </div>
    <div class="mb20">
      <b class="fs16">邮件发送列表</b>
    </div>
    <div class="filterContainer">
      <div class="mr10">
        <span class="w70 tar title">校验订阅：</span>
        <a-select
          ref="select"
          v-model:value="postParams.emailTriggerState"
          style="width: 140px"
          :allowClear="true"
        >
          <a-select-option :value="null">全部</a-select-option>
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
      </div>
      <div class="mr10">
        <span class="w70 tar title">邮件状态：</span>
        <a-select
          ref="select"
          v-model:value="postParams.emailTriggerState"
          style="width: 140px"
          :allowClear="true"
        >
          <a-select-option :value="null">全部</a-select-option>
          <a-select-option :value="1">成功</a-select-option>
          <a-select-option :value="-1">失败</a-select-option>
        </a-select>
      </div>
      <div class="mr10">
        <span class="w80 tar title">用户邮箱：</span>
        <a-input
          v-model:value="postParams.email"
          style="width: 140px;"
          placeholder="请输入"
        />
      </div>
      <div class="mr20">
        <span class="w60 tar title">时间：</span>
        <a-range-picker
          style="width: 200px;"
          @change="e => changeFilterTime(e)"
          v-model:value="postParams.timeSet"
          show-time
          :placeholder="['开始时间', '结束时间']"
        />
      </div>
      <div class="mr10 tar">
        <a-button class="mr10" @click="() => resetParams()">重置</a-button>
        <a-button type="primary" @click="resetPagination">查询</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { inject, toRefs, reactive } from 'vue'
export default {
  setup() {
    const state = reactive({
      open: false
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.filter {
  background: #ffffff;
}

.filterContainer {
  display: flex;
  flex-direction: row;
}

.filter .title {
  display: inline-block;
}
</style>
